export class MotosNotImplementedError extends Error {
  static create(errorMessage) {
    return new MotosNotImplementedError(errorMessage)
  }
}
